import React, { useState } from "react";
import { Lifebuoy } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { TicketForm } from "./TicketForm";
import { SupportTicketForm } from "./SupportTicketForm";
import { TicketLodged } from "./TicketOffer";

export function TicketDialog({ open, onOpenChange, onLodged, standalone }) {
  const [lodged, setLodged] = useState(null);
  const change = (v) => { onOpenChange(v); if (!v) setLodged(null); };
  const Form = standalone ? SupportTicketForm : TicketForm;
  return (
    <Dialog open={open} onOpenChange={change}>
      <DialogContent className="bg-[#0A0A0A] border-neutral-800 text-neutral-200 max-w-lg max-h-[92vh] overflow-y-auto" data-testid="ticket-dialog"
        onInteractOutside={(e) => standalone && !lodged && e.preventDefault()}
        onEscapeKeyDown={(e) => standalone && !lodged && e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="font-heading text-white flex items-center gap-2"><Lifebuoy size={20} className="text-[#73bf44]" weight="duotone" /> Technical support ticket</DialogTitle>
          <DialogDescription className="text-neutral-500">
            {standalone ? "For technical assistance only (not warranty claims). Tell us what's going on and the OTM tech team will get back to you." : "Tell us what's going on and the OTM tech team will get back to you."}
          </DialogDescription>
        </DialogHeader>
        {open && (lodged ? <TicketLodged reference={lodged} /> : (
          <Form onDone={(t) => { setLodged(t.reference); onLodged?.(t); }} onCancel={() => change(false)} />
        ))}
      </DialogContent>
    </Dialog>
  );
}
